export default "__VITE_ASSET__B8s2ez_G__"